module.exports = __webpack_public_path__ + "static/scale-model-of-pappajohn-sculpture-park-in-des-moines-iowa-9be89c0f1ae8edd49f5c1e124317f93a.png";